export const iconFontAwesomeNumbers8 = (
	<i className="fa-solid fa-8"></i>
);
